import React from "react"
import { Container } from "./styled"
import logo from "../../../img/evo-logo.png"

const Logo = () => {
  return (
    <Container>
      <div>
        <img src={logo} alt="Evo logo" />
      </div>
    </Container>
  )
}

export default Logo
